<template>
  <!-- todo translate-->
  <div class="TooltipBubble text-left" data-number="1">
    <div class="flex items-center">
      <ui-pictogram size="large" class="mr-3 !bg-bc-blue !text-white"
        >VN</ui-pictogram
      >

      <div class="leading-tight flex-grow">
        <div class="font-medium">Václav Netolický</div>
        <div class="text-xs">15:33 dnes</div>
      </div>
      <div class="px-3 py-1 hover:bg-gray-100 cursor-pointer leading-tight">
        <aw-icon
          icon="tick"
          class="relative w-4 h-4 -mx-1  text-green-600"
        ></aw-icon>
      </div>
    </div>
    <div class="mt-2 leading-snug text-sm">
      option for all logo
    </div>

    <!-- reakce / komenty atd?  -->
    <div class="my-3 -mx-4 h-0.25 bg-gray-200"></div>
    <div class="Tooltip_Reaction text-gray-400 mt-4 mb-4">
      <div class="flex">
        <ui-pictogram size="default" class="mr-3 !bg-green-600 !text-white"
          >KD</ui-pictogram
        >

        <div class="leading-tight flex-grow">
          <div class="text-sm">Karel Drašnar</div>
          <div class="text-xs">23:33 včera</div>
        </div>
      </div>
      <div class="mt-1 leading-snug text-sm">
        Vašku, změn to prosím dle požadavků
        <a href="#" class="text-bc-blue">@BillGates</a>, já jsem ted na Bahamách
        🏝😋👙
      </div>
    </div>
    <div class="my-2 -mx-4 h-0.25"></div>
    <div class="Tooltip_Reaction text-gray-400 mt-4 mb-4">
      <div class="flex">
        <ui-pictogram size="default" class="mr-3 !bg-indigo-600 !text-white"
          >BG</ui-pictogram
        >
        <div class="leading-tight flex-grow">
          <div class="text-sm">Bill Gates <span>(klient)</span></div>
          <div class="text-xs">20:33 včera</div>
        </div>
      </div>
      <div class="mt-1 leading-snug text-sm">
        Prosím o změnu textu na něco smysluplného 🔥
      </div>
    </div>

    <div class="my-3 -mx-4 h-0.25 bg-gray-200"></div>
    <div class="mt-2">
      <textarea
        placeholder="Your comment"
        class="w-full border-gray-400 rounded text-sm"
      ></textarea>
    </div>
    <div class="mt-1 -mx-4 h-0.25"></div>
    <a href="#" class="btn btn-primary btn-xs mr-2">Odpovědět</a>
    <a href="#" class="btn btn-secondary btn-xs">Zrušit</a>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped></style>
